import { generateCurrentTimestamp, getAccessToken, getRefreshToken, saveAccessToken, saveRefreshToken } from '../../api/utils/tokens.ts'
import { createContextHelper } from '../../utils/context.tsx'
import {
  clearLocalStorageExcept,
  localStorageHelper
} from '../../utils/localStorage.ts'
import { AuthAction, AuthState } from './types.ts'

const createInitialAuthState = (): AuthState => {
  const accessToken = getAccessToken()
  const refreshToken = getRefreshToken()
  const email = localStorageHelper.getItem('email')
  const groups = localStorageHelper.getItem('groups')
  let groupsAsArray: string[] = []

  if (groups && groups !== 'undefined' && groups !== 'null') {
    groupsAsArray = JSON.parse(groups)
  }

  return {
    isAuthenticated: !!(accessToken && refreshToken),
    accessToken: accessToken || null,
    refreshToken: refreshToken || null,
    email: email || null,
    groups: groupsAsArray || null
  }
}

const authReducer = (state: AuthState, action: AuthAction): AuthState => {
  switch (action.type) {
    case 'LOGIN':
      const currentTimestamp = generateCurrentTimestamp()
      saveAccessToken(action.payload.accessToken, currentTimestamp)
      saveRefreshToken(action.payload.refreshToken, currentTimestamp)
      localStorageHelper.setItem('email', action.payload.email)
      localStorageHelper.setItem(
        'groups',
        JSON.stringify(action.payload.groups)
      )

      return {
        ...state,
        isAuthenticated: true,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        email: action.payload.email,
        groups: action.payload.groups
      }

    case 'LOGOUT':
      clearLocalStorageExcept(['agreement','certificate'])
      return {
        ...state,
        isAuthenticated: false,
        accessToken: null,
        refreshToken: null,
        email: null,
        groups: null
      }

      case 'UPDATE_USER_GROUPS':
        return {
          ...state,
          groups: action.payload.groups
        }

    default:
      throw new Error('Unhandled action type')
  }
}

const initialAuthState: AuthState = createInitialAuthState()

const { Provider, useContext } = createContextHelper(
  authReducer,
  initialAuthState
)

export const AuthProvider = Provider
export const useAuth = useContext
